import React from "react";
import LineaPagoModalMultiple from "../../sportsProductsNewQuote/lineaPagoModalMultiple/LineaPagoModalMultiple";
import {
  Button,
  Container,
  Alert,
  Form,
  FormGroup,
  Label,
  Row,
  Col
} from "reactstrap";

interface Props {}

interface State {
  lineaPagoMultipleModalIsOpen: boolean;
}

class TestComponent extends React.Component<Props, State> {
  state = {
    lineaPagoMultipleModalIsOpen: false
  };

  showLineasPagoMultipleModal = () => {
    this.setState({ lineaPagoMultipleModalIsOpen: true });
  };

  hideLineasPagoMultipleModal = () => {
    this.setState({ lineaPagoMultipleModalIsOpen: false });
  };

  render() {
    return (
      <div>
        <LineaPagoModalMultiple
          isOpen={this.state.lineaPagoMultipleModalIsOpen}
          amount={5000}
          hasMembershipsOrTokenizationProducts={false}
          hasMaintenancesProducts={false}
          showTokenizationControl={false}
          generarLineaPago={lineasPago => {
            console.info(lineasPago);
            this.hideLineasPagoMultipleModal();
          }}
          cancelar={() => {
            this.hideLineasPagoMultipleModal();
          }}
        />
        <div>
          <span>Linea de pago multiple: </span>
          <Button
            className={"bg-secondary"}
            onClick={e => {
              e.preventDefault();
              this.showLineasPagoMultipleModal();
            }}
            size="xs"
            disabled={false}
          >
            Linea de pago multiple
          </Button>
        </div>
      </div>
    );
  }
}

export default TestComponent;
